import React from 'react';
import { LoadingInline } from '../../app/components';
import ImagesWrapper from './ImagesWrapper';
import { DragDropContext } from 'react-dnd';
import MultiBackend, { Preview } from 'react-dnd-multi-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';
import './styles.css';

class ImagesStep extends React.Component {
  generatePreview = (type, item, style) => {
    const styles = {
      ...style,
      backgroundImage: item.backgroundImage,
      width: 'calc(30% - 20px)',
      paddingBottom: 'calc(30% - 20px)',
      float: 'left',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
    };
    return <div style={styles} />;
  };

  render() {
    const {
      onImageChange, imagePreviewUrls, onDeselectImage, onMoveImage, findImage, uploadingFiles,
    } = this.props;

    return (
      <div className="step-content images-step">
        <h2>Myndir</h2>
        <p>
          Finndu allar ágætar myndir sem þú átt af eigninni þinni.<br />
          Mundu að hafa bestu myndina fremst, því fyrstu kynni skipta máli.
        </p>
        <div className="input-wrapper">
          <input
            name="file"
            id="file"
            type="file"
            multiple
            onChange={onImageChange}
          />
          <label htmlFor="file">
            Bæta við myndum
          </label>
        </div>
        <div className="images-wrapper">
          <LoadingInline loading={uploadingFiles} loadingColor="#00e39a" backgroundColor="#ffffff" />
          <ImagesWrapper
            imagePreviewUrls={imagePreviewUrls}
            onDeselectImage={onDeselectImage}
            onMoveImage={onMoveImage}
            findImage={findImage}
          />
        </div>
        <Preview generator={this.generatePreview} />
      </div>
    );
  }
}

ImagesStep.propTypes = {
  imagePreviewUrls: React.PropTypes.array.isRequired,
  draggingImageIndex: React.PropTypes.any,
  onMoveImage: React.PropTypes.func.isRequired,
  findImage: React.PropTypes.func.isRequired,
  onImageChange: React.PropTypes.func.isRequired,
  onDeselectImage: React.PropTypes.func.isRequired,
  uploadingFiles: React.PropTypes.bool.isRequired,
};

export default DragDropContext(MultiBackend(HTML5Backend, TouchBackend))(ImagesStep);



// WEBPACK FOOTER //
// ./src/browser/steps/ImagesStep/ImagesStep.js